import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getQuote } from "../services/http-service/getQuote";
import { IGetQuote } from "../interfaces/IgetQuote";

export const useGetQuote = ({ getQuoteData, enabled }: { getQuoteData: IGetQuote; enabled: boolean }) => {
  const {
    isLoading: loadingGetQuote,
    isFetching: fetchingGetQuote,
    isError: errorFetchingGetQuote,
    data: getQuoteResponse,
    error: errorGetQuoteResponse,
    refetch: refetchGetQuote,
  } = useQuery({
    queryKey: ["GetQuote"],
    queryFn: async () => await getQuote(getQuoteData),
    enabled: enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
  });
  const fetchGetQuoteError = (errorGetQuoteResponse as AxiosError)?.response?.data;

  return {
    loadingGetQuote,
    fetchingGetQuote,
    errorFetchingGetQuote,
    getQuoteResponse,
    fetchGetQuoteError,
    refetchGetQuote,
  };
};
